var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { flatten, uniq } from '../../../utils/helper/lodash_replacements';
export class ActorAttachedTraits {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get actor() {
        return this.parent;
    }
    allAttachedTraitsOfKey(traitKey) {
        return uniq(flatten(this.actor.actorAspects.allAspectsArray.map(aspect => aspect.aspectCollectedSets.allAtsOfKey(traitKey))));
    }
    get allAttachedActorTraitsDeep() {
        return uniq(flatten(this.actor.actorAspects.allAspectsArray.map(aspect => aspect.aspectContent.global.activeContentAts)));
    }
    get allAttachedTraitsDeep() {
        return uniq(flatten(this.actor.actorAspects.allAspectsArray.map(aspect => aspect.aspectAttached.attachedTraits)));
    }
}
__decorate([
    computed
], ActorAttachedTraits.prototype, "allAttachedActorTraitsDeep", null);
__decorate([
    computed
], ActorAttachedTraits.prototype, "allAttachedTraitsDeep", null);
